import { render } from "./Metar.vue?vue&type=template&id=52eaddc6&scoped=true"
import script from "./Metar.vue?vue&type=script&lang=js"
export * from "./Metar.vue?vue&type=script&lang=js"

import "./Metar.vue?vue&type=style&index=0&id=52eaddc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52eaddc6"]])

export default __exports__